<template lang="pug">
  .group_contact__item(
    @click="onClick",
    :class="[contact.type, { selected, 'special': contact.special, 'new': contact.newMessage }]")
    .group_contact__wrap
      .group_contact__preview
        div(v-if="contact.avatar_url", :style="{ 'background-image': 'url(' + contact.avatar_url + ')' }")
        AvatarPlaceholder.md(v-else, :fullName="contact.first_name + ' ' + contact.last_name", :classname="getAvatarClass(contact.first_name, contact.last_name)")
      .group_contact__info
        .group_contact__info__name
          span {{ contact.first_name }} {{ contact.last_name }}
        .group_contact__info__shortmsg {{ contact.message }}
    v-checkbox.main_checkbox.group_contact__checkbox(
      v-model="checked",
      @change="onChange",
      :true-value="true",
      color="#19a2dc")
</template>

<script>
import AvatarPlaceholder from '@/components/AvatarPlaceholder';
import SvgMsgLogo from '@/components/svg/SvgMsgLogo';
import SvgMsgGroup from '@/components/svg/SvgMsgGroup';
import SvgMsgDollar from '@/components/svg/SvgMsgDollar';
import { getAvatarClass } from '@/utils';

export default {
  components: {
    AvatarPlaceholder,
    SvgMsgLogo,
    SvgMsgGroup,
    SvgMsgDollar
  },
  props: {
    contact: { type: Object, required: true },
    selected: { type: Boolean, default: false }
  },
  data() {
    return {
      getAvatarClass,
      checked: this.selected
    };
  },
  methods: {
    onClick() {
      this.checked = !this.checked;
      this.$emit('onContactCheck', this.contact.id);
    },
    onChange() {
      this.checked = !this.checked;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/variables';

  .group_contact {
    &__item {
      width: 100%;
      position: relative;
      cursor: pointer;
      border-radius: 6px;

      &:hover { background: $blue-lighter-01; }

      &.selected { background: $light-theme-line; }
    }

    &__wrap {
      padding: 10px 16px;
      display: flex;
      align-items: center;
      width: 100%;
    }

    &__preview > div:not(.v-avatar) {
      width: 50px;
      height: 50px;
      background: $light-theme-line center;
      background-size: cover;
      border-radius: 50%;
      min-width: 50px;
    }

    &__info {
      margin-left: 14px;
      max-width: 250px;
      width: 100%;
      position: relative;

      &__name {
        display: flex;
        align-items: center;
        line-height: normal;
        font-size: 16px;
        color: $sub-black;
        font-weight: 600;
        width: 100%;
        position: relative;

        span {
          text-align: left;
          display: block;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          max-width: 170px;
        }
      }

      &__shortmsg {
        line-height: normal;
        font-size: 12px;
        text-align: left;
        margin-top: 8px;
        color: $light-theme-text;
        font-weight: 600;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 85%;
      }
    }

    &__checkbox {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 28px;
      height: 33px;
      margin: auto;
    }
  }

</style>
